/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PastiNonOrdinariStudenti } from './pastiNonOrdinariStudenti';
import { ResocontoPastiClasseSezione } from './resocontoPastiClasseSezione';

export interface ResocontoPastiStudenti { 
    intestazioneScuola?: string;
    ordinamento?: ResocontoPastiStudenti.OrdinamentoEnum;
    numeroPastiOrdinari?: number;
    pastiNonOrdinari?: Array<PastiNonOrdinariStudenti>;
    pastiPerSezioneClasse?: Array<ResocontoPastiClasseSezione>;
}
export namespace ResocontoPastiStudenti {
    export type OrdinamentoEnum = 'SCUOLA_INFANZIA' | 'PRIMARIA';
    export const OrdinamentoEnum = {
        SCUOLAINFANZIA: 'SCUOLA_INFANZIA' as OrdinamentoEnum,
        PRIMARIA: 'PRIMARIA' as OrdinamentoEnum
    };
}